import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

/**
 * Componente de Comparación de Barras de Progreso con 3 valores.
 */
const ComparisonBarTripleComponent = ({
    parameter,
    left,
    center,
    right,
    metricTotal = null,
    isHigherBetter = true,
}) => {
    const theme = useTheme();

    const parse = (val) => parseFloat(val) || 0;
    const leftVal = parse(left);
    const centerVal = parse(center);
    const rightVal = parse(right);
    const total = metricTotal ?? leftVal + centerVal + rightVal;

    const getPercent = (val) => (total === 0 ? 0 : (val / total) * 100);

    const leftColor = '#206945';
    const centerBarColor = '#2196F3';
    const rightColor = '#963c3c';

    return (
        <Box sx={{ mb: 2 }}>
            <Typography variant="h6" fontSize={12} mb={0.5}>
                {parameter}
            </Typography>

            {/* Barra de comparación */}
            <Box
                sx={{
                    display: 'flex',
                    height: 6,
                    width: '100%',
                    borderRadius: 10,
                    overflow: 'hidden',
                    boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.15)',
                }}
            >
                <Box
                    sx={{
                        width: `${getPercent(leftVal)}%`,
                        backgroundColor: leftColor,
                        transition: 'width 0.5s',
                    }}
                />
                <Box
                    sx={{
                        width: `${getPercent(centerVal)}%`,
                        backgroundColor: centerBarColor,
                        transition: 'width 0.5s',
                    }}
                />
                <Box
                    sx={{
                        width: `${getPercent(rightVal)}%`,
                        backgroundColor: rightColor,
                        transition: 'width 0.5s',
                    }}
                />
            </Box>

            {/* Números debajo */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mt: 0.5,
                }}
            >
                <Typography sx={{ fontSize: 12 }}>{left}%</Typography>
                <Typography sx={{ fontSize: 12 }}>{center}%</Typography>
                <Typography sx={{ fontSize: 12 }}>{right}%</Typography>
            </Box>
        </Box>
    );
};

export default ComparisonBarTripleComponent;
